import React, { Component } from 'react';
interface ErrorBoundaryProps {
  children: React.ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }
  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Slide render error:', error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return <div className="w-full min-h-screen flex items-center justify-center bg-[#FAFAF8] px-6" data-id="element-70">
          <div className="max-w-md w-full bg-white rounded-2xl p-8 shadow-sm border border-red-100 space-y-4 text-center" data-id="element-71">
            <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center mx-auto" data-id="element-72">
              <span className="text-2xl" data-id="element-73">⚠️</span>
            </div>
            <h2 className="text-xl font-bold text-[#1C1917]" data-id="element-74">
              Something went wrong
            </h2>
            <p className="text-sm text-[#57534E]" data-id="element-75">
              {this.state.error?.message}
            </p>
            <button onClick={() => this.setState({
            hasError: false,
            error: null
          })} className="px-6 py-2.5 bg-[#1C1917] text-white font-bold rounded-xl hover:bg-neutral-800 transition-all" data-id="element-76">
              Try again
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}